import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useAdmin } from '../../hooks/useAdmin';
import { menuItems } from '../../config/menuItems';
import CustomerLoginPage from './CustomerLoginPage';

interface Props {
  children: React.ReactNode;
}

export function CustomerProtectedRoute({ children }: Props) {
  useEffect(() => {
    const prevTitle = document.title;
    const link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
    const prevHref = link?.href ?? '';
    const prevType = link?.type ?? '';

    document.title = 'PestConnect Live';
    if (link) {
      link.type = 'image/x-icon';
      link.href = '/static/rentokil-com.ico';
    }

    return () => {
      document.title = prevTitle;
      if (link) {
        link.type = prevType;
        link.href = prevHref;
      }
    };
  }, []);
  const { user, loading: authLoading, isAuthorized } = useAuth();
  const { enabledCards, loading: adminLoading } = useAdmin();
  const location = useLocation();

  if (authLoading || adminLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="spinner" />
      </div>
    );
  }

  if (!user || !isAuthorized) {
    return <CustomerLoginPage />;
  }

  // Check if the current route is an enabled feature for this tenant
  const currentPath = location.pathname.replace(/^\/customer/, '') || '/';
  const matchedItem = menuItems.find(item => item.path === currentPath);

  if (matchedItem && enabledCards !== null && !enabledCards.includes(matchedItem.id)) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', gap: '16px' }}>
        <h2>Access Restricted</h2>
        <p>This feature has not been enabled for your account.</p>
        <button onClick={() => window.history.back()} style={{ padding: '8px 16px', cursor: 'pointer' }}>
          Go Back
        </button>
      </div>
    );
  }

  return <div className="customer-route">{children}</div>;
}
